module.exports = __webpack_public_path__ + "static/media/Artboard6.5c1b86fc.png";